<template>
    <div class="echart-chart-block">
        <div :id="chartID" class="chart-tall"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import echarts from 'echarts'

export default {
    props:
    {
        chartID: {
            type: String,
            required: true,
        },
        data: {
            type: Object,
            default: function () { return {} }
        },
        showToolbox: {
            type: Boolean,
            default: true,
        },
        preSaveName: {
            type: String,
            default: '',
        },
        displayColor: {
            type: String,
            // default: 'red',
        },
        filterTextMax: {
            type: String,
        },
        filterTextMin: {
            type: String,
        },
    },
    data () {
        return {
            theChart: undefined,
            lastValue: undefined,

            calendar_range: [],
            calendar_dates: [],
            calendar_harvest_dates: [],
        }
    },
    mounted () {
        this.theChart = echarts.init(document.getElementById( this.chartID ));
        this.arrangeData()
        this.drawChartPrepare();
    },
    computed: {
        ...mapState({
            'language': state => state.user.language,
            'screenWidth': state => state.system.screenWidth,
            'contentWidth': state => state.system.contentWidth,
        }),

        getEchartsLanguage ()
        {
            switch (this.language)
            {
                case 'zh-Hant-TW':
                case 'zh-Hant':
                case 'zh-Hans': return 'cn';
                default: return 'en';
            }
        },
    },
    watch: {
        // 偵測到 [ 語言 ] 變動就更新圖表
        language ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 資料 ] 變動就更新圖表
        data ()
        {
            this.arrangeData()
            this.drawChartPrepare();
        },


        // 偵測到 [ 視窗寬度 ] 變動就更新圖表
        screenWidth (val, oldVal)
        {
            if ( val != oldVal && this.theChart != undefined )
            {
                this.theChart.resize()
            }
        },
        // 偵測到 [ 版面寬度 ] 變動就更新圖表
        contentWidth (val, oldVal)
        {
            if ( val != oldVal && this.theChart != undefined )
            {
                this.theChart.resize()
            }
        },
    },
    methods: {

        arrangeData ()
        {
            this.calendar_dates = []
            this.calendar_harvest_dates = []
            this.calendar_range = ''

            if ( this.data && this.data.min_harvest_date != undefined && this.data.max_harvest_date != undefined )
            {
                let _start = this.data.min_harvest_date
                let _end = this.data.max_harvest_date

                this.calendar_range = [
                    this.$moment( _start ).startOf('month').format('YYYY-MM-DD'),
                    this.$moment( _end ).endOf('month').format('YYYY-MM-DD')
                ]

                let _harvest_days_list = []
                let _days_count_harvest = this.$tools.date.countPastTime( _start, _end, 'days', false )
                for (let i=0; i<=_days_count_harvest; i++)
                {
                    let _day = this.$tools.date.getDateShift( _start, i, 'days', 'YYYY-MM-DD' )
                    _harvest_days_list.push( _day )

                    this.calendar_harvest_dates.push([
                        _day,
                        1
                    ])
                }

                let _days_count_all = this.$tools.date.countPastTime( this.calendar_range[0], this.calendar_range[1], 'days', false )
                for (let i=0; i<=_days_count_all; i++)
                {
                    let _day = this.$tools.date.getDateShift( this.calendar_range[0], i, 'days', 'YYYY-MM-DD' )
                    this.calendar_dates.push([
                        _day,
                        ( _harvest_days_list.indexOf( _day ) == -1 ? 0 : 1 )
                    ])
                }
            }
        },

        drawChartPrepare ()
        {
            // if ( this.data && this.data != {} ) {
                this.drawChart( this.theChart,
                                this.data,
                                this.showToolbox );
            // }
        },  
        drawChart ( chart,
                    _data,
                    _showToolbox )
        {
            // let hours = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10','11','12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'];
            let _weekdays = [
                this.$t('date.Sun'),
                this.$t('date.Mon'),
                this.$t('date.Tue'),
                this.$t('date.Wed'),
                this.$t('date.Thu'),
                this.$t('date.Fri'),
                this.$t('date.Sat'),
            ];
            let _color = '#ff3377';
            


            
            
            // 檢查視窗大小，顯示/隱藏項目
            let _chartWidth = chart.getWidth();
            let _this = this

            let option = {
                // title: {
                //     padding: 15,
                //     text: this.$t('menu.harvest_prediction') + ' ' + this.$t('menu.calendar'),
                // },
                // toolbox: ecTools.createToolbox( this.chartID, this.preSaveName + ' - ' + _stressName + ' - HeatMap Chart', _showToolbox ),
                tooltip:
                {
                    formatter: function (params) {
                        // console.log(params);
                        let _tooltip = params.data[0] + '<br>'
                        _tooltip += '<i class="fa fa-circle" style="color:'+ params.color +';"></i> ' + _this.$t('menu.harvest_prediction');
                        
                        return _tooltip;
                    },
                },
                grid:
                [
                    {
                        id: 0,
                        // x: '3%',
                        top: '8%',
                        bottom: '16%',
                        width: '95%',
                    },
                ],
                xAxis:
                [
                    {
                        gridIndex: 0,
                        type: 'category',
                        nameGap: 5,
                        splitArea: { show: false },
                        axisLine: { show: false },
                        axisTick: { show: false }
                    },
                ],
                yAxis:
                [
                    {
                        gridIndex: 0,
                        type: 'category',
                        splitArea: { show: false },
                        axisLine: { show: false },
                        axisTick: { show: false }
                    },
                ],
                visualMap: [
                    {
                        show: false,
                        min: 0,
                        max: 1,
                    },
                ],
                calendar: [
                    {
                        orient: 'vertical',
                        top: 60,
                        // right: 55,
                        height: 255,
                        yearLabel: {
                            align: 'center',
                            verticalAlign: 'middle',
                            margin: 35,
                            color: '#174232',
                            fontWeight: 600,
                        },
                        monthLabel: {
                            align: 'center',
                            verticalAlign: 'middle',
                            margin: 10,
                            nameMap: this.getEchartsLanguage,
                        },
                        dayLabel: {
                            margin: 10,
                            firstDay: 0,
                            nameMap: _weekdays,
                        },
                        cellSize: 35,
                        range: this.calendar_range, //'2018-01' 或 ['2020-03-01', '2020-04-30']
                    },
                ],
                series: [
                    {
                        type: 'scatter',
                        coordinateSystem: 'calendar',
                        symbolSize: 1,
                        label: {
                            show: true,
                            formatter: function (params) {
                                // console.log( params )
                                let _displayInfo = _this.$moment( params.value[0] ).date()
                                if ( params.value[1] == 1 ) _displayInfo += '\n採收'

                                return _displayInfo
                            },
                            color: '#000'
                        },
                        data: this.calendar_dates,
                    },
                    {
                        type: 'heatmap',
                        coordinateSystem: 'calendar',
                        data: this.calendar_harvest_dates,
                    },
                ],
                animation: true,
            };
            chart.setOption(option);
        },

    }
    
}
</script>

<style lang="scss" scoped>

.chart-tall
{
    width: 360px;
    height: 320px;
    margin-left: -40px;
}


</style>
